module.exports = __webpack_public_path__ + "static/assets/a03436c2c26c934fc0a7997065971874.png";